import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { RequestContext } from "../../context/request.context";

const UpdateCategory = ({ user, action }) => {
  const { request } = useContext(RequestContext);
  const [categories, setCategories] = useState([]);
  const [categoryIds, setCategoryIds] = useState(
    user.selectedCategories.map((item) => item.id)
  );
  const [onlySelectedCategories, setOnlySelectedCategories] = useState(
    user.onlySelectedCategories
  );
  useEffect(() => {
    request(`/category/all`, "GET").then((res) => {
      setCategories(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "0.5rem",
        padding: "1rem",
      }}
    >
      <Typography variant="h6" textAlign={"center"}>
        Kategoriyalar
      </Typography>
      <Autocomplete
        size="small"
        multiple
        id="tags-outlined"
        options={categories}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        defaultValue={user.selectedCategories}
        onChange={(event, value) => {
          setCategoryIds(value.map((item) => item.id));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Kategoriyalar"
            placeholder="Kategoriyalar"
          />
        )}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="caption">
          Faqat tanlangan kategoriyalardan foydalanish
        </Typography>
        <Checkbox
          size="small"
          checked={onlySelectedCategories}
          onChange={(e) => {
            setOnlySelectedCategories(e.target.checked);
          }}
        />
      </Box>

      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={async () => {
          action({
            categoryIds,
            onlySelectedCategories,
          });
        }}
      >
        Saqlash
      </Button>
    </Box>
  );
};

export default UpdateCategory;
